<div class="wrapper border rounded-[5px] p-[15px]">
  <div class="bid-item flex flex-col mb-[20px]">
    <div class="item text-type-5">
      {{ data?.bid_item?.item }}
    </div>
    <div class="details text-type-11">
      {{ data?.bid_item?.description }}
    </div>
  </div>
  <div class="row flex flex-col mb-[20px]">
    <div class="label">
      Test Name:
    </div>
    <div class="value">
      {{ data?.material_test?.name }}
    </div>
  </div>
  <div class="row flex flex-col mb-[20px]">
    <div class="label">
      Lab Name:
    </div>
    <div class="value">
      {{ data?.lab?.name }}
    </div>
  </div>
  <div class="row w-full flex flex-row mb-[20px]">
    <div class="sub-row w-1/2 flex flex-col mb-[20px]">
      <div class="label">
        Date:
      </div>
      <div class="value">
        {{ data?.request_date | dateFormat: 'long' }}
      </div>
    </div>
    <div class="sub-row w-1/2 flex flex-col mb-[20px]">
      <div class="label">
        Time:
      </div>
      <div class="value">
        {{ time }}
      </div>
    </div>
  </div>
  @if (data?.comment) {
    <div class="row flex flex-col mb-[20px]">
      <div class="label">
        Comments:
      </div>
      <div class="value">
        {{ data?.comment }}
      </div>
    </div>
  }
  @if (mediaFiles?.length) {
    <app-pictures-section
      [isEditable]="false"
      [pictures]="mediaFiles"
      class="pictures-section mb-[20px]"
      />
  }
  @if (data?.latitude !== null &&
    data?.longitude !== null &&
    data?.latitude !== '' &&
    data?.longitude !== '') {
    <app-location-section
      [isEditable]="false"
      [latitude]="data?.latitude"
      [longitude]="data?.longitude"
      class="location-section"
      />
  }
</div>
